import useI18n from '@/shared/hooks/usei18n'
import { Button, IconButton, TableCell, TableRow } from '@/common'
import { TrashIcon } from '@/common/components/icons'
import { Partnership } from '@/features/suppliers/hooks/partnerships'
import ReactCountryFlag from 'react-country-flag'
import { useNavigate } from 'react-router-dom'
import { Installation } from '@/features/suppliers/hooks/installations'
import { ImportedGood } from '@/features/cbam-reporting/hooks/importedGoods'

export default function SupplierRow({
  supplier,
  importedGoods,
  installations,
  onDeleteClick
}: {
  supplier: Partnership
  importedGoods: ImportedGood[]
  installations: Installation[]
  onDeleteClick: () => void
}) {
  const { t } = useI18n()
  const navigate = useNavigate()

  const numberOfInstallations = installations.length

  const quantityReported = importedGoods.reduce(
    (acc, importedGood) => acc + importedGood.netMassInTonnes,
    0
  )

  return (
    <TableRow key={supplier.id}>
      <TableCell>
        <div className="flex items-center gap-1.5">
          <ReactCountryFlag countryCode={supplier.country} svg /> <span>{supplier.name}</span>
        </div>
      </TableCell>
      <TableCell>
        <p>{supplier.operatorCity}</p>
        <p className="text-sm">{t(`common:countriesByIsoAlpha2.${supplier.country}`)}</p>
      </TableCell>
      <TableCell align="right">{numberOfInstallations}</TableCell>
      <TableCell align="right">{importedGoods.length ? `${quantityReported} t` : '-'}</TableCell>
      <TableCell align="right">
        <div className="flex items-center gap-2 justify-end">
          <Button variant="txt-default" sizeType="sm" onClick={() => navigate(`./${supplier.id}`)}>
            {t('suppliers:suppliersPage.suppliersList.supplierTable.actions.viewSupplier')}
          </Button>
          <IconButton
            icon={<TrashIcon />}
            variant="txt-danger"
            sizeType="sm"
            onClick={onDeleteClick}
          />
        </div>
      </TableCell>
    </TableRow>
  )
}
